import ComposableMedicalFormEvaluator from "../types/ComposableMedicalFormEvaluator";
import IMedicalQuestionnaireCompleteEvaluator from "../types/IMedicalQualificationCompleteEvaluator";
import IMedicalQualificationNonCandidateEvaluator from "../types/IMedicalQualificationNonCandidateEvaluator";
import { DiabeticFormEvaluatorConfig } from "./ComposedDiabeticMedicalQuestions";
import { GeneralMedicalQuestionsEvaluatorConfig } from "./ComposedGeneralMedicalQuestions";
import { PacemakerFormEvaluatorConfig } from "./ComposedPacemakerMedicalQuestions";
import { RadiationFormEvaluatorConfig } from "./ComposedRadiationMedicalQuestions";

/** A medical form evaluator capable of analyzing the complete medical form state across all independent steps. */
const AllMedicalQuestionsEvaluator: IMedicalQualificationNonCandidateEvaluator &
  IMedicalQuestionnaireCompleteEvaluator = new ComposableMedicalFormEvaluator({
  allFormQuestionIds: [
    ...GeneralMedicalQuestionsEvaluatorConfig.allFormQuestionIds,
    ...DiabeticFormEvaluatorConfig.allFormQuestionIds,
    ...PacemakerFormEvaluatorConfig.allFormQuestionIds,
    ...RadiationFormEvaluatorConfig.allFormQuestionIds
  ],
  nonCandidateIgnoredQuestionIds: [
    ...(GeneralMedicalQuestionsEvaluatorConfig.nonCandidateIgnoredQuestionIds ?? []),
    ...(DiabeticFormEvaluatorConfig.nonCandidateIgnoredQuestionIds ?? []),
    ...(PacemakerFormEvaluatorConfig.nonCandidateIgnoredQuestionIds ?? []),
    ...(RadiationFormEvaluatorConfig.nonCandidateIgnoredQuestionIds ?? [])
  ],
  requiredQuestionPredicates: {
    ...GeneralMedicalQuestionsEvaluatorConfig.requiredQuestionPredicates,
    ...DiabeticFormEvaluatorConfig.requiredQuestionPredicates,
    ...PacemakerFormEvaluatorConfig.requiredQuestionPredicates,
    ...RadiationFormEvaluatorConfig.requiredQuestionPredicates
  },
  nonCandidateQuestionPredicates: {
    ...GeneralMedicalQuestionsEvaluatorConfig.nonCandidateQuestionPredicates,
    ...DiabeticFormEvaluatorConfig.nonCandidateQuestionPredicates,
    ...PacemakerFormEvaluatorConfig.nonCandidateQuestionPredicates,
    ...RadiationFormEvaluatorConfig.nonCandidateQuestionPredicates
  }
});

export default AllMedicalQuestionsEvaluator;
